var _path, _rect, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPtah(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 311,
    viewBox: "0 0 264 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.494 36.3796L200.94 60.0696L182.629 25.3998L223.765 20.9596L208.451 41.0699L243.494 36.3796Z",
    fill: "#FF3416"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 80.0848,
    width: 193.242,
    height: 193.242,
    transform: "rotate(-18.6151 19 80.0848)",
    fill: "#F7CB25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.532 47.9697L152.062 56.4629",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.936 56.7197L149.08 61.8045",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.048 68.314L149.987 67.2418",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5668,
    cy: 14.5668,
    r: 14.5668,
    transform: "matrix(-0.817515 0.575908 0.575908 0.817515 165.783 44.4026)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.90006,
    cy: 6.90006,
    r: 6.90006,
    transform: "matrix(-0.817515 0.575908 0.575908 0.817515 165.431 52.7782)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0386 228.768L152.588 168.729L134.201 96.2578L46.6262 143.001L101.771 165.644L76.0386 228.768Z",
    fill: "#3E3092",
    stroke: "#3E3092"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.172 263.736V215.18L159.875 212.624V263.736L174.379 265.269V270.38L162.775 267.314L168.577 277.536H159.875L154.073 267.314L143.436 270.38L138.601 267.314L151.172 263.736Z",
    fill: "#3E3092"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.982 262.748V214.192L198.684 211.637V262.748L213.189 264.282V269.393L201.585 266.326L207.387 276.549H198.684L192.882 266.326L182.246 269.393L177.411 266.326L189.982 262.748Z",
    fill: "#3E3092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02981 260.591L77.2059 230L81.8067 252.938L37.6333 305.446L32.4827 300.077L37.5114 287.429L25.6521 292.136L20.9487 286.096L31.7949 270.535L17.2537 282.181L9.527 272.673L22.2792 263.714L7.1737 266.744L3.02981 260.591Z",
    fill: "#F7CB25"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtah);
export default __webpack_public_path__ + "static/media/ptah.aa2105fb0d1fa10b17f16597258e7269.svg";
export { ForwardRef as ReactComponent };